import React from "react";

import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../../../styles/estilos.css";
import Page from "components/Page";
import ImgExitoso from "assets/img/icono-exitoso.png";
import ValoresCotizacion from "../../../../components/Cotizacion/ValoresCotizacion";
import ListadoProductos from "../../../../components/Cotizacion/ListaProductosCotizacion/ListadoProductos";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { urlAccesoBackoffice } from "../../../../constants/urls";

class Cotizacion5FinalAsesor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placa: "",
      validate: false,
      hasPlacaError: true,
      chasis: "",
    };
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  onCancel = () => {
    window.location.href = "/logout";
  }
  onClick = (event) => {
    //console.log("Entre a evento onCLik")
    event.preventDefault();
    // this.props.history.replace({
    //   pathname: "/cotizacion",
    //   search: `?accion=nuevo`
    // });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
    this.props.history.replace({
      pathname: "/listado-renovaciones"
    });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
  }


  onClickAdministrador = (event) => {
    //console.log("Entre a evento onCLik")
    event.preventDefault();
    // this.props.history.replace({
    //   pathname: "/cotizacion",
    //   search: `?accion=nuevo`
    // });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
    this.props.history.replace({
      pathname: `${urlAccesoBackoffice}?idUsuario=${Buffer.from(
        this.props.datosUsuario
          .cliCodigoCore
      ).toString("base64")}`
    });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    console.log('datosCarrito', this.props.datosCarrito, this.props.datosCotizacion)
  }


  render() {
    let titulo = 'Renovación De Vehículos'
    const queryParams = new URLSearchParams(this.props.location.search);
    let ramo = queryParams.get('ramo');
    if (ramo && ramo !== undefined && ramo != "") {
      if (ramo === "VH") {
        titulo = 'Renovación De Vehículos'
      }
      if (ramo === "HOG") {
        titulo = 'Cotización De Hogar'
      }
      else if (ramo === "TRV") {
        titulo = 'Cotización De Travel'
      }
      else if (ramo === "RCANDINA") {
        titulo = 'Cotización De Responsabilidad Civil Andina'
      }
      else if (ramo === "PYMES") {
        titulo = 'Cotización De Pymes'
      }
      else if (ramo === "AP") {
        titulo = 'Cotización De Accidentes Personales'
      }
      else if (ramo === "CYBER") {
        titulo = 'Cotización De Cyber Edge'
      }
      else if (ramo === "DYO") {
        titulo = 'Cotización De D&O'
      }
      else if (ramo === "RCPIE") {
        titulo = 'Cotización De Responsabilidad Civil Profesional Para Instituciones Educativas'
      }
      else if (ramo === "RCP") {
        titulo = 'Cotización De Responsabilidad Civil Profesional'
      }
      else  if (ramo === "RCGENERAL")
      {
        titulo='Cotización de Responsabilidad Civil'
      }
    }
    return (
      <Page
        title={titulo}
        breadcrumbs={[{ name: titulo, active: true }]}
      >
        <Row>
          <Col lg={8} md={12} sm={12} xs={12}>
            <div className="container-step">
              <div className="wrapper-step">
                <div className="arrow-steps clearfix-step">
                  <div className="step">
                    {" "}
                    <span>1. Renovación</span>{" "}
                  </div>
                  <div className="step">
                    {" "}
                    <span>2. Resumen</span>{" "}
                  </div>
                  <div className="step ">
                    {" "}
                    <span>3. Confirmación</span>{" "}
                  </div>
                  <div class="step"> {` 4. Forma de Pago `} </div>
                  <div class="step "> {` 5. Formulario de Vinculación `} </div>
                  <div class="step current"> {` 6. Emisión `} </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <div style={{ padding: "1em" }}>
                      <h2 style={{ color: "#001871" }}> PROCESO DE EMISIÓN INICIADO</h2>
                      <br></br>
                      {this.props.datosUsuario && this.props.datosUsuario.usu_tipo_usuario !== 'cliente' &&
                        <div>
                          <h2> {`Los datos del Contratante y Pagador han sido registrados existosamente`}.</h2>
                          {/* <h2> {`A continuación el contratante deberá completar su formulario de vinculación`}.</h2> */}
                          <h2> {`Si desea consultar el estado de esta compra, por favor dirigirse a la sección "Pólizas Renovaciones Auto" en el administrador`}.</h2>
                        </div>
                      }
                      {this.props.datosUsuario && this.props.datosUsuario.usu_tipo_usuario === 'cliente' &&
                        <div>
                          <h2> Los datos del Facturación y Pago han sido registrados <strong>existosamente</strong>.</h2>
                          <h2> A continuación, deberá recibir un <strong>correo electrónico</strong> para completar su <strong>formulario de vinculación</strong>.</h2>
                          <h2> Si desea consultar el estado de esta compra, por favor dirigirse a la sección <strong>"Listado de Compras"</strong> pulsaldo el ícono de usuario ubicado en la parte superior derecha de su pantalla.</h2>
                        </div>
                      }
                      <br></br>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ textAlign: "center" }}
                  >
                    <img src={ImgExitoso} width="100px"></img>
                    <div style={{ paddingBottom: "1em" }}></div>
                    {this.props.datosUsuario && !this.props.datosUsuario.clienteFinal &&
                      <Button
                        className={
                          "btn btn-primary"
                        }
                        onClick={this.onClick}
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"NUEVA RENOVACIÓN"}
                      </Button>
                    }

                    {this.props.datosUsuario && !this.props.datosUsuario.clienteFinal &&
                      <a
                       
                        target='_blank'
                        href={`${urlAccesoBackoffice}?idUsuario=${Buffer.from(
                          this.props.datosUsuario
                            .cliCodigoCore
                        ).toString("base64")}`}
                        style={{ display: "block", margin: "auto", marginTop: 10 }}
                      >
                      

                        <Button
                        className={
                          "btn btn-primary"
                        }
              
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"PÓLIZAS RENOVACIONES AUTO"}
                      </Button>
                      </a>
                    }
                    {this.props.datosUsuario && this.props.datosUsuario.clienteFinal &&
                      <Button
                        className={
                          "btn btn-primary"
                        }
                        onClick={this.onCancel}
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"SALIR DE LA COTIZACIÓN"}
                      </Button>
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <div style={{ paddingTop: "30em" }}></div>
        </Row>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  datosUsuario: state.datosUsuarios.dataUsuario,
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Cotizacion5FinalAsesor)
);
//export default withRouter(Cotizacion5FinalAsesor);
